<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yTZuB5/tc-custom/9781680572223.jpg?1705236028773" alt="This image is the cover for the book Mayflies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mayflies
      </h1>
      <p class="bookDescription body article font2">
        <b>A man is unwillingly transformed into the sentient command core of a starship on a thousand-year journey—with thousands of passengers at his mercy . . .</b><br/>  <br/><i>Transient. Ethereal. Delicate. Insignificant. Mere insects</i> . . . Like all the human beings trapped aboard a vast starship on a generations-long journey to a new home. The <i>Mayflower</i> is run by an immortal captain who views himself as a god. Gerard Metaclura was just a normal man until a terrible accident left him near dead, his body destroyed. But his brain was installed as the sentient command core of the generation ship.<br/>  <br/> At first Gerard was confused by what happened to him. Then angry. Then bored. Now he is the ship, controlling everything . . . including 25,000 helpless human passengers. <i>Mayflies</i>.<br/>  <br/> But maybe they’re not willing to be so helpless and insignificant after all . . . 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin O'Donnell
      </h2>
      
      <p class="authorDescription body article">As the author of ten published novels and over seventy published short stories and articles, Kevin O’Donnell, Jr. had a devoted following of readers. One of his most popular and beloved works is the McGill Feighan series, a fast-paced and fun science fiction romp. Kevin was an active contributor to the Science Fiction and Fantasy Writers Association. He chaired SFWA’s Nebula Award Committee, ran SFWA’s Bulletin, and served as Chairman of SFWA’s Grievance Committee, where he fought unceasingly for the rights of authors in an era of growing Internet piracy and corporate disregard of personal copyrights. As a result of these activities, he received the Service to SFWA Award. Kevin spent much of his teen years in South Korea, where his father was Country Director for the Peace Corps. His interest in Asia and language skills led him to take his degree at Yale in Chinese Studies, where he met his wife Kim, with whom he was happily married until his passing in 2012. An avid gardener, O'Donnell delighted in raising bonsai, vegetables, and assorted plants. WordFire Press is pleased to bring the works of Kevin O’Donnell, Jr. back into print for a new audience.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42c73029